import styled, { css } from 'styled-components'

export const InputWrapper = styled.div<{ isError?: boolean; isNotEmpty?: boolean }>`
	position: relative;
	font-size: 14px;
	margin-bottom: 24px;
	input {
		font-size: 16px;
		line-height: 24px;
		color: white;
		background-color: #1bbb4f;
		border: none;
		border-bottom: 1px solid ${({ isError }) => (isError ? '#f44336' : 'rgba(255, 255, 255, 0.56)')};
		border-radius: 0;
		box-shadow: none;
		display: inline-block;
		width: 100%;
		height: auto;
		padding: 16px;
		padding-left: 0px;
		font-family: Open Sans, serif;
		font-style: normal;
		font-weight: normal;
		outline: none;
		outline-color: initial;
		outline-style: none;
		outline-width: initial;
		overflow: hidden;
		transition: all 0.3s;

		@media only screen and (max-width: 1199px) {
			font-size: 12px;
			line-height: 16px;
		}

		&::placeholder {
			color: white;
		}

		${({ isNotEmpty }) =>
			isNotEmpty &&
			css`
				padding-top: 24px;
				padding-bottom: 8px;
			`}

		&:-webkit-autofill,
		&:-webkit-autofill:hover,
		&:-webkit-autofill:focus {
			border-bottom: 1px solid
				${({ isError }) => (isError ? '#f44336' : 'rgba(255, 255, 255, 0.56)')};
			-webkit-text-fill-color: white;
			-webkit-box-shadow: 0 0 0px 1000px #1bbb4f inset;
			transition: background-color 5000s ease-in-out 0s;
			font-size: 16px;
			line-height: 24px;
			background-color: rgb(27, 187, 79);
			caret-color: white;
		}
	}

	.placeholder {
		position: absolute;
		display: block;
		top: 8px;
		font-size: 12px;
		line-height: 16px;
		transition: all 0.2s linear;
		background-color: #1bbb4f;
		color: #fff;
		left: 0px;
		z-index: 1;
	}
`
